import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  item,
  FORSUBMIT,
  CLEAR,
  BULK_ASSIGN_FORSUBMIT
} from '@hobs/constants/assignmentServiceRequest';

class AssigmentServiceRequest extends BaseReducer {
  static defaultState = {
    item: {},
    forSubmit: {
      subcontractors: [],
      valueAddedTaxes: [],
      activities: []
    },
    bulkForSubmit: []
  };
  constructor() {
    super(AssigmentServiceRequest.defaultState);

    this.actionMap = {
      [item.SUCCESS]: this.addAssigmentServiceRequestItem,
      [FORSUBMIT.SUCCESS]: this.addForSubmitData,
      [CLEAR.SUCCESS]: this.clearAssigmentServiceRequestItem,
      [BULK_ASSIGN_FORSUBMIT.SUCCESS]: this.loadBulkForSubmitData
    };
  }

  addAssigmentServiceRequestItem = (state, action) => {
    return Object.assign({}, state, { item: action.item });
  };

  addForSubmitData = (state, action) => {
    return Object.assign({}, state, { forSubmit: action.forSubmit });
  };

  clearAssigmentServiceRequestItem = state => {
    return Object.assign({}, state, { item: {} });
  };

  loadBulkForSubmitData = (state, action) => {
    return Object.assign({}, state, { bulkForSubmit: action.bulkForSubmit });
  };
}
export default new AssigmentServiceRequest().reducer;
